import { render, staticRenderFns } from "./CaptureImage.vue?vue&type=template&id=1d009f41&"
import script from "./CaptureImage.vue?vue&type=script&lang=js&"
export * from "./CaptureImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports